import React from 'react';
import TemplateComponent, {TemplateComponentProps} from "../../containers/template_page/template_component/template_component";
import {Col, Container, Row} from "react-bootstrap";
import './text_center_enlabs.scss';
import {insertHtml} from "../../utils/dom";

interface TextComponentData {
    title?: string;
    content: string;
}

class TextCenterEnLabs extends TemplateComponent<TextComponentData, TemplateComponentProps<TextComponentData>> {
    
    componentRender(data: TextComponentData): React.ReactElement<any> {
        return (
            <Container fluid={true} className="center-content-enlabs">
                <Row>
                    <Col xs={12} sm={6} className={'p-0'}>
                        <div className="text-center-enlabs">
                            {data.title &&
                                <h3 className={'title'}>{data.title}</h3>
                            }
                            <p className="text editor-html editor-html-right-col text-sm-left text-md-center" {...insertHtml(data.content)} />
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default TextCenterEnLabs;
